
import { computed, defineComponent } from 'vue';
import { useRoute } from 'vue-router';
import { NAVIGATION_PAGES } from '@/types/enums';
// temporary disabled CASE-1683
// import AppBadge from '@/components/AppBadge.vue';
import { useMainStore } from '@/store/mainStore';
import { useMessagesStore } from '@/modules/messages/store/messagesStore';
import AppBadge from '@/components/AppBadge.vue';
import { IConversationItemDirectList, IConversationItemGroupList } from '@/types/interfaces';

export default defineComponent({
  components: {
    AppBadge,
  },
  setup() {
    const route = useRoute();
    const mainStore = useMainStore();
    const messagesStore = useMessagesStore();

    const currentPage = computed(() => route.meta.navigationPage);

    const isDrive = computed(
      () => !!(
        currentPage.value === NAVIGATION_PAGES.NETWORK
        || currentPage.value === NAVIGATION_PAGES.NETWORK_PHOTOS
        || currentPage.value === NAVIGATION_PAGES.NETWORK_FILES
        || currentPage.value === NAVIGATION_PAGES.NETWORK_CASES
        || currentPage.value === NAVIGATION_PAGES.DRIVE
        || currentPage.value === NAVIGATION_PAGES.CASE_EDIT
        || currentPage.value === NAVIGATION_PAGES.CASE_VIEW
        || currentPage.value === NAVIGATION_PAGES.CASE_CREATE
        || currentPage.value === NAVIGATION_PAGES.DRIVE_PHOTOS
        || currentPage.value === NAVIGATION_PAGES.DRIVE_FILES
        || currentPage.value === NAVIGATION_PAGES.DRIVE_CASES
        || currentPage.value === NAVIGATION_PAGES.DRIVE_FOLDER
      ),
    );
    const isMessages = computed(() => (currentPage.value === NAVIGATION_PAGES.MESSAGES_MY
      || currentPage.value === NAVIGATION_PAGES.MESSAGES_ID
      || currentPage.value === NAVIGATION_PAGES.MESSAGES_GROUP_CHAT_ID
    ));
    const isAlerts = computed(() => currentPage.value === NAVIGATION_PAGES.ALERTS);
    const isSettings = computed(() => currentPage.value === NAVIGATION_PAGES.SETTINGS);
    const isContacts = computed(() => currentPage.value === NAVIGATION_PAGES.SPACES_CONTACTS
      || currentPage.value === NAVIGATION_PAGES.SPACES_ADD_CONTACTS
      || currentPage.value === NAVIGATION_PAGES.SPACES_GROUPS
      || currentPage.value === NAVIGATION_PAGES.SPACES_MANAGE
      || currentPage.value === NAVIGATION_PAGES.SPACES_GROUP_INFO
      || currentPage.value === NAVIGATION_PAGES.SPACES_GROUP_SETTINGS
      || currentPage.value === NAVIGATION_PAGES.SPACES_GROUP_MEMBERS
      || currentPage.value === NAVIGATION_PAGES.SPACES_GROUP_NAME);

    const currentMessagesRoute = computed(() => {
      if (messagesStore.conversations.length) {
        const { partner } = messagesStore.conversations[0] as IConversationItemDirectList;
        const { group } = messagesStore.conversations[0] as IConversationItemGroupList;

        if (partner) {
          return `/messages/${partner.accountId}`;
        }

        if (group) {
          return `/messages/group/${group.id}`;
        }
      }

      return '/messages/my';
    });

    return {
      currentPage,
      NAVIGATION_PAGES,
      mainStore,
      isDrive,
      isMessages,
      isAlerts,
      isContacts,
      isSettings,
      currentMessagesRoute,
    };
  },
});
